/* ======================================================================
   shop-the-look.js
   À charger GLOBALEMENT dans theme.liquid (avant </body>) :

     <script src="{{ 'shop-the-look.js' | asset_url }}" defer></script>

   Pourquoi global et pas dans le snippet ?
   Le snippet est rendu dans le cart drawer (cart != empty). Quand le drawer
   se re-render (innerHTML), les <script> injectés NE s'exécutent PAS. Chargé
   ici, le JS est posé une fois par page et ses listeners délégués gèrent les
   boutons injectés dynamiquement. -> plus besoin de recharger la page.
   ====================================================================== */

/* ----------------------------------------------------------------------
   1) SLIDER (dots) — idempotent (survit aux reloads du drawer)
---------------------------------------------------------------------- */
(function () {
  function initSTLSliders(root) {
    root = root || document;
    var wrappers = root.querySelectorAll('.stl-wrapper');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.stlInit === 'true') return;

      var slider = wrapper.querySelector('[data-shop-the-look-slider]');
      var dotsContainer = wrapper.querySelector('[data-shop-the-look-dots]');
      if (!slider || !dotsContainer) return;

      var cards = slider.querySelectorAll('.stl-card');
      if (!cards.length) return;

      wrapper.dataset.stlInit = 'true';

      dotsContainer.innerHTML = '';
      cards.forEach(function (card, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'stl-slider__dot';
        btn.setAttribute('data-stl-dot-index', index);
        dotsContainer.appendChild(btn);
      });

      var dots = dotsContainer.querySelectorAll('.stl-slider__dot');

      function setActiveDot(activeIndex) {
        dots.forEach(function (dot, index) {
          dot.classList.toggle('stl-slider__dot--active', index === activeIndex);
        });
      }

      dotsContainer.addEventListener('click', function (event) {
        var target = event.target.closest('.stl-slider__dot');
        if (!target) return;
        var index = parseInt(target.getAttribute('data-stl-dot-index'), 10);
        if (isNaN(index) || !cards[index]) return;
        slider.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
        setActiveDot(index);
      });

      var scrollRaf;
      function updateActiveDotOnScroll() {
        var sliderRect = slider.getBoundingClientRect();
        var sliderCenter = slider.scrollLeft + sliderRect.width / 2;
        var closestIndex = 0;
        var minDist = Infinity;
        cards.forEach(function (card, index) {
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var dist = Math.abs(cardCenter - sliderCenter);
          if (dist < minDist) { minDist = dist; closestIndex = index; }
        });
        setActiveDot(closestIndex);
      }

      slider.addEventListener('scroll', function () {
        if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
        scrollRaf = window.requestAnimationFrame(updateActiveDotOnScroll);
      });

      setActiveDot(0);
    });
  }

  if (document.readyState !== 'loading') {
    initSTLSliders();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initSTLSliders(); });
  }

  // Ré-init quand le drawer se recharge (innerHTML remplacé)
  var drawer = document.querySelector('cart-drawer');
  if (drawer && !window.__stlObserver) {
    var reinitRaf;
    window.__stlObserver = new MutationObserver(function () {
      if (reinitRaf) window.cancelAnimationFrame(reinitRaf);
      reinitRaf = window.requestAnimationFrame(function () { initSTLSliders(drawer); });
    });
    window.__stlObserver.observe(drawer, { childList: true, subtree: true });
  }

  window.initSTLSliders = initSTLSliders;
})();


/* ----------------------------------------------------------------------
   2) AJOUT DIRECT AU PANIER (mode handle) — sélection unique
   Listener délégué sur document -> gère les boutons injectés dynamiquement.
---------------------------------------------------------------------- */
(function () {
  if (window.__stlAddBound) return;
  window.__stlAddBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-stl-add]');
    if (!btn || btn.hasAttribute('disabled')) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = document.querySelector('cart-drawer');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var sectionsToRender =
      (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];

    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        // _free_gift : marque la ligne comme cadeau (masquée car commence par "_").
        items: [{ id: Number(variantId), quantity: 1, properties: { _free_gift: '1' } }],
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          console.warn('STL add:', state.description || state.message);
          return;
        }

        btn.classList.remove('is-loading');
        btn.textContent = btn.getAttribute('data-added-label') || 'Ajouté';
        btn.classList.add('stl-card__btn--added');

        var wrapper = btn.closest('.stl-wrapper');
        if (wrapper) {
          var thisCard = btn.closest('.stl-card');
          wrapper.querySelectorAll('.stl-card').forEach(function (card) {
            if (card === thisCard) return;
            var otherBtn = card.querySelector('[data-stl-add]');
            var otherTitle = card.querySelector('.stl-card__title');
            if (otherBtn) otherBtn.setAttribute('disabled', 'disabled');
            if (otherTitle) otherTitle.classList.add('stl-card__title--muted');
          });
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(state);
        }
      })
      .catch(function (e) { console.error('STL add error:', e); })
      .finally(function () {
        btn.classList.remove('is-loading');
        if (btn.classList.contains('stl-card__btn--added')) {
          btn.removeAttribute('disabled');
        }
      });
  });
})();


/* ----------------------------------------------------------------------
   3) AUTO-SUPPRESSION DU CADEAU sous le seuil
   Le seuil est calculé sur le sous-total HORS lignes cadeau : l'automatic
   discount qui met le puzzle à 0 € ne s'applique qu'au checkout, donc
   cart.total_price compte encore son prix plein -> on le retranche.
   Déclenché uniquement sur les mutations du panier (change/update), pas au load.
---------------------------------------------------------------------- */
(function () {
  if (window.__stlGiftGuardBound) return;
  window.__stlGiftGuardBound = true;

  var GIFT_THRESHOLD = 7500;     // 75 € en centimes (aligné avec gift_threshold en Liquid)
  var GIFT_PROP = '_free_gift';
  var DEBUG = true;              // passe à false une fois validé
  var busy = false;
  var scheduled = false;

  function log() {
    if (DEBUG) console.log.apply(console, ['[gift-guard]'].concat([].slice.call(arguments)));
  }

  function isCartMutation(url) {
    return typeof url === 'string'
      && /\/cart\/(change|update)/.test(url)
      && url.indexOf('/cart/add') === -1;
  }

  var origFetch = window.fetch;

  // Intercepteur fetch
  window.fetch = function () {
    var first = arguments[0];
    var url = (first && first.url) ? first.url : String(first || '');
    var p = origFetch.apply(this, arguments);
    if (isCartMutation(url) && !busy) {
      log('fetch mutation détectée:', url);
      p.then(function () { scheduleCheck(); }).catch(function () {});
    }
    return p;
  };

  // Intercepteur XHR (si la logique packs passe par XHR)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__giftUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__giftUrl) && !busy) {
      log('xhr mutation détectée:', this.__giftUrl);
      this.addEventListener('load', function () { scheduleCheck(); });
    }
    return origSend.apply(this, arguments);
  };

  function scheduleCheck() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; runCheck(); }, 80);
  }

  function runCheck() {
    if (busy) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Sous-total HORS lignes cadeau (le prix du puzzle ne doit pas compter)
        var eligibleSubtotal = cart.total_price;
        cart.items.forEach(function (item) {
          if (item.properties && item.properties[GIFT_PROP]) {
            eligibleSubtotal -= item.final_line_price;
          }
        });
        log('sous-total hors cadeau =', eligibleSubtotal, '| seuil =', GIFT_THRESHOLD);
        if (eligibleSubtotal > GIFT_THRESHOLD) { log('seuil atteint -> rien à faire'); return; }

        var updates = {};
        var found = false;
        cart.items.forEach(function (item) {
          if (item.properties && item.properties[GIFT_PROP]) {
            updates[item.key] = 0;
            found = true;
          }
        });
        log('lignes cadeau à retirer ?', found, updates);
        if (!found) return;

        busy = true;

        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsToRender =
          (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
            ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
            : ['cart-drawer', 'cart-icon-bubble'];

        return origFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionsToRender,
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            log('cadeau(x) retiré(s)');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(state);
            }
          })
          .finally(function () { busy = false; });
      })
      .catch(function (e) { log('erreur', e); busy = false; });
  }
})();
